export default "__VITE_ASSET__DK9e$y3F__"